import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import { getHistoryTransfer } from "store/actions";
import { tableFormateDate } from "../utils";

const HistoryMailTransferModal = props => {
  const dispatch = useDispatch();
  const { isOpen, toggle, id, path } = props;
  //   const [typeSign, setTypeSign] = useState(TYPE_SIGN.HSM);
  const { data, loading } = useSelector(
    state => state.dataFormat.historyTransfer
  );

  useEffect(() => {
    if (isOpen) {
      dispatch(getHistoryTransfer(id, path));
    }
  }, [isOpen]);

  return (
    <Modal
      size="sm"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      style={{ minWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>Lịch sử gửi mail</Label>
        </ModalHeader>
        {loading ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="0"
              countButton="2"
              formClass="row-cols-1 row-cols-md-1"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr className="text-info">
                      <th scope="col">STT</th>
                      <th scope="col">Thời điểm gửi</th>
                      <th scope="col">Người gửi</th>
                      <th scope="col">Hành động</th>
                      <th scope="col">Danh sách email gửi đến</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data &&
                      data.map((field, index) => {
                        return (
                          <React.Fragment key={index}>
                            <tr>
                              <td>{index + 1}</td>
                              <td style={{ minWidth: "200px" }}>
                                {tableFormateDate(field.maker_date, true)}
                              </td>
                              <td style={{ minWidth: "180px" }}>
                                {field?.name}
                              </td>
                              <td style={{ minWidth: "180px" }}>
                                {field?.action}
                              </td>
                              <td>
                                {field?.ext_value?.map((item, index) => {
                                  return (
                                    <span
                                      className="font-size-14 tag-item"
                                      key={index}
                                    >
                                      {item}
                                    </span>
                                  );
                                })}
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </ModalBody>
          </React.Fragment>
        )}
      </div>
    </Modal>
  );
};

HistoryMailTransferModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  t: PropTypes.any,
  id: PropTypes.any,
  path: PropTypes.any,
};

export default HistoryMailTransferModal;
